export type AppEntry =
  | { kind: 'enter' }
  | { kind: 'enter-with-workspace'; workspaceId: number }
  | { kind: 'leave' }

/**
 * The Vue router's /app guard as a decision. A session — a token and a positive
 * saved workspace — enters, carrying the saved workspace into the URL when the
 * URL has none; anything else leaves for the marketing site.
 */
export function decideAppEntry(
  workspaceIdInUrl: number | undefined,
  storage: Pick<Storage, 'getItem'>,
): AppEntry {
  const token = storage.getItem('auth_token')
  const saved = parseInt(storage.getItem('workspace_id') ?? '', 10)
  if (!token || !(saved > 0)) return { kind: 'leave' }
  return workspaceIdInUrl === undefined ? { kind: 'enter-with-workspace', workspaceId: saved } : { kind: 'enter' }
}
